import React, { FC } from 'react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid'

export const CalcHeaderChevron: FC<{ open?: boolean }> = ({ open }) => {
  return open ? <ChevronUpIcon className="-mr-0.5 w-3" /> : <ChevronDownIcon className="-mr-0.5 w-3" />
}
